import React from 'react';
import { InterPoint } from '@saviynt/common';
import { Chip, Tooltip } from '@saviynt/design-system';

import { IS_READ_ONLY } from '../../constants';
import { useInvertedLocalize } from '../../hooks';

const RISK_PRIORITY_MAP: Record<string, Record<string, string>> = {
  VERY_LOW: { text: 'Very Low', color: 'success' },
  LOW: { text: 'Low', color: 'success' },
  MEDIUM: { text: 'Medium', color: 'warning' },
  HIGH: { text: 'High', color: 'orange' },
  CRITICAL: { text: 'Critical', color: 'critical' },
} as const;

interface RiskPriorityChipProps {
  priority: string | null;
  riskScore: number | null;
  isPrefixInterpoint?: boolean;
  isDashReturn?: boolean;
}

/**
 * For risk priority chip
 */
function SodRiskPriorityChip({
  priority,
  riskScore,
  isPrefixInterpoint,
  isDashReturn,
}: RiskPriorityChipProps) {
  const l = useInvertedLocalize();

  if (!priority || !Object.keys(RISK_PRIORITY_MAP).includes(priority)) {
    return isDashReturn ? '-' : null;
  }

  let label = `${RISK_PRIORITY_MAP[priority].text}`;
  const { color } = RISK_PRIORITY_MAP[priority];

  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (riskScore !== null && !IS_READ_ONLY) {
    label += ` (${riskScore})`;
  }

  return (
    <>
      <Tooltip
        trigger={
          <Chip
            size='xSmall'
            kind='subtleFilled'
            label={l(label)}
            color={color}
          />
        }
        text=''
        placement='bottom'
      />
      {isPrefixInterpoint && <InterPoint color='neutralBold' font='body2' />}
    </>
  );
}

SodRiskPriorityChip.defaultProps = {
  isPrefixInterpoint: true,
  isDashReturn: false,
};

export default SodRiskPriorityChip;
